import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CircleLoaderComponent,
  LoadingAnimationComponent,
  SecondaryLoadingAnimationComponent,
  GlobalLoaderComponent,
  GenericLoadingAnimationComponent
} from './components';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { AssetsService, LoaderManagerService } from './services';
import { TranslateModule } from '@ngx-translate/core';
import { ASSETS_PATH } from '@anecdotes/design-system/injection-tokens';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';

@NgModule({
  imports: [CommonModule, LottieComponent, SvgIconsModule, TranslateModule],
  declarations: [CircleLoaderComponent, LoadingAnimationComponent, SecondaryLoadingAnimationComponent, GlobalLoaderComponent, GenericLoadingAnimationComponent],
  exports: [CircleLoaderComponent, LoadingAnimationComponent, SecondaryLoadingAnimationComponent, GlobalLoaderComponent, GenericLoadingAnimationComponent],
  providers: [
    {
      provide: ASSETS_PATH,
      useValue: 'apps/assets'
    },
  ]
})
export class LoadersModule {
  static forRoot(): ModuleWithProviders<LoadersModule> {
    return {
      ngModule: LoadersModule,
      providers: [
        LoaderManagerService,
        AssetsService,
        provideLottieOptions({
          player: () => player,
        })
      ]
    };
  }
}
